export const SPRAY_APPLICATION_RECORD_STATUSES = {
    SCHEDULED: "scheduled",
    IN_PROGRESS: "in_progress",
    NEEDS_FINALIZATION: "needs_finalization",
    COMPLETED: "completed",
};

export const SPRAY_APPLICATION_RECORD_STATUS_TEXT_CLASSES = {
    [SPRAY_APPLICATION_RECORD_STATUSES.SCHEDULED]: "text-gray-500",
    [SPRAY_APPLICATION_RECORD_STATUSES.IN_PROGRESS]: "text-harvustorange",
    [SPRAY_APPLICATION_RECORD_STATUSES.NEEDS_FINALIZATION]:
        "text-harvustorange",
    [SPRAY_APPLICATION_RECORD_STATUSES.COMPLETED]: "text-harvustgreen",
};

export function getSprayApplicationRecordStatusTextClass(status) {
    return (
        SPRAY_APPLICATION_RECORD_STATUS_TEXT_CLASSES[status] || "text-gray-500"
    );
}

export const SPRAY_APPLICATION_EXECUTION_TYPES = {
    REALTIME: "realtime",
    FULL: "full",
};
